import CoreApp from "./core/coreApp";
import LazyDisp from "./components/lazydisp";
import $ from 'jquery';

const [d] = [document];

export default class CUSTOMIZE extends CoreApp {

  constructor(opt) {
    opt = Object.assign({
      // header: '.site-header',
      // pagetop: '.c-pagetop'
      // fixNavを指定すると、スクロール時に固定するクラスを付与する
      // fixNav : '[data-role="fixNav"]',
    },opt);

    // 上位クラスのコンストラクタ呼び出し
    super(opt);

    this.customInit();
  }

  customInit() {

    // イベント一覧
    d.addEventListener('app.beforeInit', () => false );
    d.addEventListener('app.beforeDomready', () => false );
    d.addEventListener('app.beforeWindowload', () => false );
    d.addEventListener('app.zip2addr', () => false );
    d.addEventListener('Scroll.beforeInit', () => false );
    d.addEventListener('Scroll.scrollUp', () => false );
    d.addEventListener('Scroll.scrollDown', () => false );
    d.addEventListener('Lazydisp.beforeInit', () => false );

    // テンプレートインスタンスのプロミス
    this.promises.init.then( () => false );
    this.promises.domReady.then( () => false );
    this.promises.windowLoad.then( () => false );

    // テンプレートインスタンスの全非同期メソッドの完了時に実行
    this.promiseAll().then( () => false );

    $(() => {
      // htmlデータ読み込み
      $('[data-load-html]').loadHtml();

      // カレントメニュー
      $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});

      Promise.all([window.load['loadHtml']]).then(() => this.hashscroll());
      Promise.all([window.load['loadHtml']]).then(() => new LazyDisp('[data-lazydisp]'));

      $('#sitenavOpen').on('click', () => {
        $('#site-navigation').addClass('open');
      });
      $('#sitenavClose').on('click', () => {
        $('#site-navigation').removeClass('open');
      });
      $('#sitenavFilter').on('click', () => {
        $('#site-navigation').removeClass('open');
      });

      // アンカーリンクスクロール
      $(function() {
          $('a[href^="#"]').click(function(e) {
              e.preventDefault();
              var href = $(this).attr("href");
              var target = $(href == "#" || href == "" ? 'html' : href);
              if (target.length) {
                  var position = target.offset().top;
                  $('body,html').animate({scrollTop: position}, 500, 'swing');
              }
          });
      });
      $(window).on('load', function() {
          var urlParams = new URLSearchParams(window.location.search);
          var anchor = urlParams.get('anchor');

          if (anchor) {
            var target = $('#' + anchor);
            if (target.length) {
              setTimeout(function() {
                var position = target.offset().top;
                $('body,html').animate({scrollTop: position}, 500, 'swing', function() {
                  var clean_url = window.location.protocol + "//" + window.location.host + window.location.pathname;
                  window.history.replaceState({ path: clean_url }, '', clean_url);
                });
              }, 100);
            }
          }
      });
    });
  }

  loading() {
    d.documentElement.classList.add( this.opt.loadingClass );
    d.documentElement.classList.add( 'is-pageload-available' );
    d.addEventListener('DOMContentLoaded', () => {
      d.documentElement.classList.remove( this.opt.loadingClass );
      d.documentElement.style.opacity = '';
    });
  }

}

window.WebFontConfig = {
  google: {
    families: ['Poppins:500', 'Roboto:100,300,500', 'Inter:500, 600', 'Noto+Sans+JP:400,500,600,700&subset=japanese']
  },
  active: function () {
    sessionStorage.fonts = true;
  }
};

(function () {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();